import { FilterPublishStatus, PlexMemberRole, PublishStatus } from '../graphql/gen/types';

export function getPublishStatuses(filterPublishStatus: FilterPublishStatus): PublishStatus[] {
  switch (filterPublishStatus) {
    case FilterPublishStatus.All:
      return [PublishStatus.Draft, PublishStatus.Internal, PublishStatus.Published];
    case FilterPublishStatus.Internal:
      return [PublishStatus.Draft, PublishStatus.Internal];
    case FilterPublishStatus.Draft:
      return [PublishStatus.Draft];
    case FilterPublishStatus.Published:
      return [PublishStatus.Published];
  }
}

const rolesRanking = {
  [PlexMemberRole.Owner]: 4,
  [PlexMemberRole.Manager]: 3,
  [PlexMemberRole.Writer]: 2,
  [PlexMemberRole.Reader]: 1,
};

export function rolesRankingSort(A: { role: PlexMemberRole }, B: { role: PlexMemberRole }): number {
  return rolesRanking[B.role] - rolesRanking[A.role];
}
